import { useQuery } from '@tanstack/react-query';
import { axiosGetV3 } from '../../api/axios-handler';

export interface AutocompleteSuggestion {
  query: string;
  highlighted_query?: string;
}

export interface AutocompleteResponse {
  suggestions: AutocompleteSuggestion[];
  algolia_time_ms: number;
}

const getAutocompleteSuggestions = async (query: string): Promise<AutocompleteResponse> => {
  const response = await axiosGetV3('/simple_search/algolia/autocomplete', { q: query.trim() });
  return response.data;
};

export const useAlgoliaAutocomplete = (query: string) => {
  const trimmedQuery = query?.trim() || '';
  const isQueryValid = trimmedQuery.length >= 2;

  const { data, isLoading, error } = useQuery<AutocompleteResponse>(
    ['algoliaAutocomplete', trimmedQuery],
    () => getAutocompleteSuggestions(trimmedQuery),
    {
      enabled: isQueryValid,
      staleTime: 30000, // Cache for 30 seconds
      cacheTime: 300000, // Keep in cache for 5 minutes
    },
  );

  return {
    suggestions: data?.suggestions || [],
    isLoading,
    error: error instanceof Error ? error : null,
  };
};
